import useIsEligibleForPasswordlessSignupFlow from 'bundles/authentication/shared/hooks/useIsEligibleForPasswordlessSignupFlow';
import { isInPasswordlessSignupVariant } from 'bundles/authentication/utils/experimentUtils';

const useIsInPasswordlessSignupFlow = () => {
  const isEligibleForPasswordlessSignupFlow = useIsEligibleForPasswordlessSignupFlow();
  return isEligibleForPasswordlessSignupFlow && isInPasswordlessSignupVariant();
};

export default useIsInPasswordlessSignupFlow;
